<template>
  <div class='main main-index'>
    <div class="main-right" v-if="show">
        <div @click="onlineConsulting">
            <p>在线咨询</p>
           <img src="/static/image/mechanism.png" alt="">
        </div>
        <div @click="insideWork">
           <p>内部办公</p>
           <img src="/static/image/mechanism.png" alt="">
        </div>
    </div>
 <div class="content-wrap">
        <div style="width:1200px;box-shadow: 0px 0px 5px 0px #DFDFDF;background: #DFDFDF;margin: 5px auto;">
          <el-carousel class="roll-box"  indicator-position='none' :autoplay="true"  ref='hots'>
					 <el-carousel-item v-for="(item, index) in imgs" :key="index">
					   <router-link  v-bind:to='""'>
						  <el-image :src="item.url" fit="cover" style="width:100%;height:100%;"></el-image>
						</router-link>
					  </el-carousel-item>
				   </el-carousel>
        </div>
    <div class="two-warp">
    <el-container  class='content'  >
      <!-- 导航页下方第一行新闻图框 -->
      <el-aside class='hots f-pr' width='526px'>
        <el-carousel height="392px" indicator-position='none' :autoplay="true" @change='handleCarousel' ref='hots'>
					<el-carousel-item v-for="(item, index) in hots" :key="index">
					  <router-link v-bind:to='"/article/show?id=" + item.id'>
						  <el-image v-bind:src="item.img" class='hot-image' fit="fill" style="width:100%;height:100%;"></el-image>
						</router-link>
					</el-carousel-item>
				</el-carousel>
        <div class="hotItem">
          <section class='hot-label f-df f-pa'>
				  <h4 class='hot-title f-oh'>{{hots[hotActive] ? hots[hotActive].title : '暂无热点新闻'}}</h4>
					<ul class='hot-indexs f-tar'>
					  <li v-for="index in hots.length" :key="index" class='hot-index f-ib f-csp f-tac' v-bind:class='hotActive == index - 1 ? "index-cur" : "index-def"' v-on:click='changehot(index - 1)'>{{index}}</li>
					</ul>
				</section>
        </div>

      </el-aside>
      <!-- 导航页下方第一行左侧的新闻通知 -->
			<el-main class='news-main'>
			  <el-tabs class='index-tabs public-tabs' type="border-card">
					<el-tab-pane label="通知公告">
            <span slot="label" class="active_img_wrap">通知公告<img src="../../../static/image/pic2.png" alt="" class="active_img">
            <img src="../../../static/image/pic3.png" alt="" class="active_img_pic">
            </span>
					  <el-empty v-if='publicities.length ==  0' description="还没有通知公告～"></el-empty>
					  <ul v-else style="height: 318px;width: 687px;overflow-y: scroll;">
						  <li class='new f-df'  v-for='(item, index) in publicities' v-bind:key='index'>
							  <router-link class='new-link f-oh' v-bind:to='"/article/show?id=" + item.id'>{{item.title}}</router-link>
								<time class='time f-tar'>{{moment(item.publishTime).format('YYYY-MM-DD')}}</time>
							</li>
						</ul>
					</el-tab-pane>
					<el-tab-pane label="龙源动态">
            <span slot="label" class="active_img_wrap">龙源动态
              <img src="../../../static/image/pic2.png" alt="" class="active_img">
            <img src="../../../static/image/pic3.png" alt="" class="active_img_pic">
            </span>
					  <el-empty v-if='news.length ==  0' description="还没有龙源动态～"></el-empty>
					  <ul v-else style="height: 318px; overflow-y: scroll;">
						  <li class='new f-df' v-for='(item, index) in news' v-bind:key='index'>
							  <router-link class='new-link f-oh' v-bind:to='"/article/show?id=" + item.id'>{{item.title}}</router-link>
								<time class='time f-tar'>{{moment(item.publishTime).format('YYYY-MM-DD')}}</time>
							</li>
						</ul>
					</el-tab-pane>
				</el-tabs>
			</el-main>
    </el-container>
        </div>
    <div class="beijing-warp">
      <el-container class='content'>
      <!-- 新加图片滚动地方 -->
		  <el-main class='dynamic-main' style="position:relative">
        <div class="scollItem"></div>
			  <el-tabs class='index-tabs dynamic-tabs' type="border-card" v-model="dyIndex">
             <el-tab-pane label="新闻动态" name="1">
              <span slot="label" class="active_img_wrap">新闻动态<img src="../../../static/image/pic2.png" alt="" class="active_img">
            <img src="../../../static/image/pic3.png" alt="" class="active_img_pic">
            </span>
              <vue-seamless-scroll :data="xwdtimgs" :class-option="defaultOption"  v-if="dyIndex==1">
                            <ul class="ul-scoll" style="display:flex">
                               <li v-for="(item, index) in xwdtimgs" :key='index' style="width:300px;height:200px;margin-left:10px">
                                   <img :src="item.img" alt="" style="width:300px;height:200px;margin-left:10px">
                                </li>
                            </ul>
              </vue-seamless-scroll>
					</el-tab-pane>
          <el-tab-pane label="近期报道" name="2">
            <span slot="label" class="active_img_wrap">近期报道<img src="../../../static/image/pic2.png" alt="" class="active_img">
            <img src="../../../static/image/pic3.png" alt="" class="active_img_pic">
            </span>
              <vue-seamless-scroll :data="jqbdimgs" :class-option="defaultOption" v-if="dyIndex == 2">
                            <ul class="ul-scoll" style="display:flex">
                               <li v-for="(item, index) in jqbdimgs" :key='index' style="width:300px;height:200px;margin-left:10px">
                                   <img :src="item.img" alt="" style="width:300px;height:200px;margin-left:10px">
                                </li>
                            </ul>
              </vue-seamless-scroll>
					</el-tab-pane>

				</el-tabs>
			</el-main>
		</el-container>
    <el-container class='content'>
      <el-main class='dynamic-main'>
			  <el-tabs class='index-tabs public-tabs' type="border-card" v-model="xyIndex">
					  <el-tab-pane label="公益园区">
             <span slot="label" class="active_img_wrap">公益园区<img src="../../../static/image/pic2.png" alt="" class="active_img">
             <img src="../../../static/image/pic3.png" alt="" class="active_img_pic">
             </span>
             <vue-seamless-scroll :data="gyyqimgs.data" :class-option="defaultOptionNew"  v-if="xyIndex==0">
                  <ul class="ul-scoll" style="display:flex;">
                      <li v-for="(item, index) in gyyqimgs.data" :key='index' >
                          <img :src="item.deadPortraitUrls" alt="" v-on:click='go("/sacrifice/show/" + item.id)' class="peopleItem">
                      </li>
                  </ul>
              </vue-seamless-scroll>
					   <!-- <el-empty v-if='qygkList.length ==  0' description="还没有企业概况～"></el-empty> -->
					   <!-- <ul  v-else style="padding:0 20px;font-size:22px;height: 250px; overflow-y: scroll;">
						   <li class='new f-df' v-for='(item, index) in qygkList' v-bind:key='index'>
							  <router-link class='new-link f-oh' v-bind:to='"/article/show?id=" + item.id'>{{item.title}}</router-link>
								<time class='time f-tar'>{{moment(item.publishTime).format('YYYY-MM-DD')}}</time>
							 </li>
						  </ul> -->
					  </el-tab-pane>
            <el-tab-pane label="名人纪念馆">
             <span slot="label" class="active_img_wrap">名人纪念馆<img src="../../../static/image/pic2.png" alt="" class="active_img">
             <img src="../../../static/image/pic3.png" alt="" class="active_img_pic">
             </span>
             <vue-seamless-scroll :data="starimgs.data" :class-option="defaultOptionNew"  v-if="xyIndex == 1">
                  <ul class="ul-scoll" style="display:flex">
                      <li v-for="(item, index) in starimgs.data" :key='index' >
                          <img :src="item.deadPortraitUrls" alt="" v-on:click='go("/sacrifice/show/" + item.id)' class="peopleItem">
                      </li>
                  </ul>
              </vue-seamless-scroll>
					   <!-- <el-empty v-if='qygkList.length ==  0' description="还没有企业概况～"></el-empty>
					   <ul  v-else style="padding:0 20px;font-size:22px;height: 250px; overflow-y: scroll;">
						   <li class='new f-df' v-for='(item, index) in qygkList' v-bind:key='index'>
							  <router-link class='new-link f-oh' v-bind:to='"/article/show?id=" + item.id'>{{item.title}}</router-link>
								<time class='time f-tar'>{{moment(item.publishTime).format('YYYY-MM-DD')}}</time>
							 </li>
						  </ul> -->
					  </el-tab-pane>
        </el-tabs>
      </el-main>
      <el-aside style="width:403px;" class='funeral'>
				<el-card class="box-card" shadow='never' style="margin-bottom:8px">
					<header slot="header" class="funeral-header f-fwb s-swb">龙源服务
           <img src="../../../static/image/pic2.png" alt="" class="active_img">
           <img src="../../../static/image/pic3.png" alt="" class="active_img_pic">
          </header>
					<el-row :gutter="10">
            <el-col :span="12" class='reserve-wrapper'>
              <div class="reserve cursor" @click="ValetSweep">
							  <img src='/static/image/icon6.png' class='reserve-icon f-pr'>
								<span>代客祭扫预约</span>
							</div>
						</el-col>
             <el-col :span="12" class='reserve-wrapper'>
                            <div class="reserve cursor" @click="btntomb">
							  <img src='/static/image/icon1.png' class='reserve-icon f-pr'>
								<span>预约看墓</span>
							</div>
						</el-col>
                        <el-col :span="12" class='reserve-wrapper'>
						  <div class="reserve cursor" @click="tombSiteSearch">
							  <img src='/static/image/icon2.png' class='reserve-icon f-pr'>
								<span>墓位信息查询</span>
							</div>
						</el-col>
            <el-col :span="12" class='reserve-wrapper'>
              <router-link v-bind:to='token ? "/sacrifice/index" : "/sacrifice/login"' class='reserve f-db'>
                <img src='/static/image/icon5.png' class='reserve-icon f-pr'>
                <span>网上纪念</span>
              </router-link>
            </el-col>
					</el-row>
				</el-card>
        <el-card class="box-card" shadow='never'>
					<header slot="header" class="funeral-header f-fwb s-swb">社会监督

            <img src="../../../static/image/pic2.png" alt="" class="active_img">
            <img src="../../../static/image/pic3.png" alt="" class="active_img_pic">
          </header>
					<el-row :gutter="10">
					  <el-col :span="12" class='reserve-wrapper'>
                            <div class='reserve f-db cursor' @click="btnpoll">
                                <img src='/static/image/icon4.png' class='reserve-icon f-pr'>
								<span>民意调查</span>
                            </div>
						</el-col>
						<el-col :span="12" class='reserve-wrapper'>
                            <div class='reserve f-db cursor' @click="supervisionInvestigation">
                                <img src='/static/image/icon5.png' class='reserve-icon f-pr'>
								<span>监督举报</span>
                            </div>
						</el-col>
					</el-row>
				</el-card>
			</el-aside>
    </el-container>
  <div>


    <!-- 导航页下方第三行左侧的殡葬文化新加tab页内容 -->
		  <!-- <el-main class='dynamic-main'>
			  <el-tabs class='index-tabs public-tabs' type="border-card">
					  <el-tab-pane label="企业概况">
            <span slot="label" class="active_img_wrap">企业概况<img src="../../../static/image/pic2.png" alt="" class="active_img">
            <img src="../../../static/image/pic3.png" alt="" class="active_img_pic">
            </span>
					  <el-empty v-if='qygkList.length ==  0' description="还没有企业概况～"></el-empty>
					  <ul  v-else style="padding:0 20px;font-size:22px;height: 250px; overflow-y: scroll;">
						  <li class='new f-df' v-for='(item, index) in qygkList' v-bind:key='index'>
							  <router-link class='new-link f-oh' v-bind:to='"/article/show?id=" + item.id'>{{item.title}}</router-link>
								<time class='time f-tar'>{{moment(item.publishTime).format('YYYY-MM-DD')}}</time>
							</li>
						</ul>
					</el-tab-pane>
            <el-tab-pane label="殡葬文化">
            <span slot="label" class="active_img_wrap">殡葬文化
              <img src="../../../static/image/pic2.png" alt="" class="active_img">
            <img src="../../../static/image/pic3.png" alt="" class="active_img_pic">
            </span>
					  <el-empty v-if='bzwhList.length ==  0' description="还没有殡葬文化～"></el-empty>
					  <ul v-else style="padding:0 20px;font-size:22px;height: 250px; overflow-y: scroll;">
						  <li class='new f-df' v-for='(item, index) in bzwhList' v-bind:key='index'>
							  <router-link class='new-link f-oh' v-bind:to='"/article/show?id=" + item.id'>{{item.title}}</router-link>
								<time class='time f-tar'>{{moment(item.publishTime).format('YYYY-MM-DD')}}</time>
							</li>
						</ul>
					</el-tab-pane>
          <el-tab-pane label="党建中心">
            <span slot="label" class="active_img_wrap">党建中心
              <img src="../../../static/image/pic2.png" alt="" class="active_img">
            <img src="../../../static/image/pic3.png" alt="" class="active_img_pic">
            </span>
					  <el-empty v-if='djzxList.length ==  0' description="还没有党建中心～"></el-empty>
					  <ul v-else style="padding:0 20px;font-size:22px;height: 250px; overflow-y: scroll;">
						  <li class='new f-df' v-for='(item, index) in djzxList' v-bind:key='index'>
							  <router-link class='new-link f-oh' v-bind:to='"/article/show?id=" + item.id'>{{item.title}}</router-link>
								<time class='time f-tar'>{{moment(item.publishTime).format('YYYY-MM-DD')}}</time>
							</li>
						</ul>
					</el-tab-pane>
          <el-tab-pane label="行业资讯">
            <span slot="label" class="active_img_wrap">行业资讯
              <img src="../../../static/image/pic2.png" alt="" class="active_img">
            <img src="../../../static/image/pic3.png" alt="" class="active_img_pic">
            </span>
					  <el-empty v-if='hyzxList.length ==  0' description="还没有行业资讯～"></el-empty>
					  <ul v-else style="padding:0 20px;font-size:22px;height: 250px; overflow-y: scroll;">
						  <li class='new f-df' v-for='(item, index) in hyzxList' v-bind:key='index'>
							  <router-link class='new-link f-oh' v-bind:to='"/article/show?id=" + item.id'>{{item.title}}</router-link>
								<time class='time f-tar'>{{moment(item.publishTime).format('YYYY-MM-DD')}}</time>
							</li>
						</ul>
					</el-tab-pane>
				</el-tabs>
			</el-main> -->
      <!-- 导航页下方第二行右侧 -->

		<!-- </el-container> -->
		<el-container class='content'>
      <!-- 导航页下方第三行的九龙源风貌 -->
		  <!-- <el-main class='dynamic-main'>
			  <el-tabs class='index-tabs dynamic-tabs' type="border-card">
             <el-tab-pane label="九龙源风貌">
              <span slot="label" class="active_img_wrap">九龙源风貌<img src="../../../static/image/pic2.png" alt="" class="active_img">
            <img src="../../../static/image/pic3.png" alt="" class="active_img_pic">
            </span>
              <vue-seamless-scroll :data="imgs" :class-option="defaultOption" >
                            <ul class="ul-scoll" style="display:flex">
                               <li v-for="(item, index) in imgs" :key='index' style="">
                                   <img :src="item.url" alt="" style="width:350px;height:220px;margin-left:10px">
                                </li>
                            </ul>
              </vue-seamless-scroll>
					</el-tab-pane>

				</el-tabs>
			</el-main> -->
		</el-container>
      </div>
    </div>
</div>
        <div class="dialog_item" v-if="zixunshow">
           <div class="chat_main">
            <i class="el-icon-close" @click="btnclose"></i>
                <div class="chat_div">
                    <ul id="chat_ul" class="chat_content">
                      {{ afterInfo }}
                    </ul>

                </div>

                <div class="send_message">
                    <form>
                        <input type="text" placeholder="请输入消息" id="send_txt" v-model="info_text">
                        <input type="button" value="发送" id="send_btn" @click="commitNews">
                    </form>
                </div>
            </div>
        </div>
        <!-- 预约看墓弹窗 -->
        <el-dialog
            title="预约看墓"
            :visible.sync="dialogVisible"
            width="50%"
            :before-close="handleClose">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
               <el-row>
                   <el-col :span="12">
                       <el-form-item label="预订姓名" prop="name">
                              <el-input v-model="ruleForm.name" ></el-input>
                      </el-form-item>
                   </el-col>
                  <el-col :span="12">
                   <el-form-item label="墓穴类型" >
                    <el-select v-model="ruleForm.expectationType" placeholder="请选择" style="width:80%">
                      <el-option v-for="(item,index) in mxTypeList" :key="index" :label="item.text" :value="item.id" />
                    </el-select>
                  </el-form-item>
                  </el-col>
               </el-row>
               <el-row>
                    <el-col :span="12">
                        <el-form-item label="联系方式" prop="phone">
                           <el-input v-model="ruleForm.phone" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="看墓时间" prop="expectationTime" style="width:150px">
                             <el-date-picker
                                   v-model="ruleForm.expectationTime"
                                   type="date"
                                   placeholder="选择日期">
                             </el-date-picker>
                        </el-form-item>
                    </el-col>
               </el-row>
               <el-row>
                 <el-col :span="12">
                     <el-form-item label="价格最低" prop="expectationLowest">
                        <el-input v-model="ruleForm.expectationLowest" ></el-input>
                     </el-form-item>
                 </el-col>
                 <el-col :span="12">
                    <el-form-item label="价格最高" prop="expectationHighest">
                       <el-input v-model="ruleForm.expectationHighest" ></el-input>
                    </el-form-item>
                 </el-col>
               </el-row>
               <el-row>
                <el-col :span="18">
                  <el-form-item label="备注" prop="remark">
                 <el-input v-model="ruleForm.remark" style="width:100%;" ></el-input>
               </el-form-item>
                </el-col>
               </el-row>

            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button style="background:#8E8E8E;border:none;"  type="primary" @click="orderCommit('ruleForm')">提 交</el-button>
            </span>
       </el-dialog>
       <!-- 代理祭祀弹窗 -->
       <el-dialog
          title="代理祭祀"
          :visible.sync="actingSacrificeShow"
          width="50%"
          :before-close="handleClose">
          <el-form ref="form" :model="form" :rules="rules" label-width="120px">
            <el-row>
             <el-col :span="9">
                <el-form-item label="身份证号">
                  <el-input v-model="form.idNumber"></el-input>
                </el-form-item>
               </el-form-item>
            </el-col>
            <el-col :span="9">
                <el-form-item label="逝者名称">
                  <el-input v-model="form.name">搜索</el-input>
                </el-form-item>
               </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="onSubmit">搜索</el-button>
                </el-form-item>
            </el-col>
          </el-row>

          </el-form>
          <div style="width:100%;height:1px;background-color:#ccc;margin-bottom:30px"></div>
          <el-form ref="form" :model="form" label-width="120px">
            <el-row>
            <el-col :span="9">
                <el-form-item label="身份证号:">
                  <span></span>
                </el-form-item>
               </el-form-item>
            </el-col>
            <el-col :span="9">
                <el-form-item label="逝者名称:">
                  <span></span>
                </el-form-item>
               </el-form-item>
            </el-col>
          </el-row>
            <el-form-item label="碑文:">
                  <span></span>
                </el-form-item>
            </el-form-item>
          </el-form>
          <div style="width:100%;height:1px;background-color:#ccc;margin-bottom:30px"></div>
          <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange">
              <el-table-column
                type="selection"
                width="55">
              </el-table-column>
              <el-table-column
                 label="服务内容"
                 prop="serviceContent"
                 width="120">
                 <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
            </el-table-column>
            <el-table-column
              prop="quantity"
              label="数量"

              width="120">
              <template slot-scope="{row,$index}">
                <el-input class="edit-cell"
                type="number"
                onkeyup="value= (value.match(/^\d*(\.?\d{0,2})/g)[0]) || null"
                v-model="row.quantity"
                min='0'
                @change="quantityChange(row.quantity,$index)"
              ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="unitPrice"
              label="单价"
              show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="totalAmount"
              label="总金额"
              show-overflow-tooltip>
              <template slot-scope="{row,$index}">
                {{row.totalAmount}}
              </template>
            </el-table-column>
         </el-table>
          <span slot="footer" class="dialog-footer">
            <el-button @click="actingSacrificeShow = false">取 消</el-button>
            <el-button type="primary" @click="btnactingSacrificeShow">确 定</el-button>
          </span>
       </el-dialog>
       <!-- 代理祭祀服务内容拍照反馈给客户 -->
       <el-dialog
         title="提示"
         :visible.sync="servicedialog"
         width="60%"
         :before-close="handleClose">
         <div class="service-box">
            <div class="service-banner">
                <img src="/static/image/serverice.png" alt="">
                <div class="service-banner-right">
                    <div class="banner-right">
                        <h1>至尊型(代客祭扫)</h1>
                    </div>
                    <p>总金额：</p>
                    <p>逝者名称：</p>
                    <p>祭祀时间：</p>
                </div>
            </div>
            <div class="expense-settlement">
                 <el-button type="primary" class="expense-settlement-button" @click="expenseSettlementButton">网上缴费</el-button>
            </div>
         </div>
         <span slot="footer" class="dialog-footer">
           <el-button @click="servicedialog = false">取 消</el-button>
           <el-button type="primary" @click="servicedialog = false">确 定</el-button>
         </span>
       </el-dialog>
       <!-- 代理祭祀服务内容费用结算 -->
       <el-dialog
         title="费用结算"
         :visible.sync="expenseSettlementDilog"
         width="30%"
         :before-close="handleClose">
         <div>
            <p>总金额：</p>
            <div style="margin-top:30px;text-align: center">
                <el-button type="primary">微信支付</el-button>
                <el-button type="success">支付宝支付</el-button>
            </div>
         </div>
         <span slot="footer" class="dialog-footer">
           <el-button @click="expenseSettlementDilog = false">取 消</el-button>
           <el-button style="background:#8E8E8E;border:none;"  type="primary" @click="expenseSettlementDilog = false">确 定</el-button>
         </span>
      </el-dialog>
        <!-- 民意调查 -->
        <el-dialog
          title="民意调查问卷"
          :visible.sync="poll"
          width="50%"
           center
          :before-close="handleClose">
          <el-form ref="pollForm" :model="pollForm" :rules="rules">
            <div style="margin-bottom:30px">
              <p style="margin-bottom:20px;font-size:20px">1,  您对我们服务的满意程度感觉如何</p>
              <el-radio-group v-model="pollForm.q1">
                 <el-radio :label="1">非常满意</el-radio>
                 <el-radio :label="2">满意</el-radio>
                 <el-radio :label="3">一般</el-radio>
                 <el-radio :label="4">不满意</el-radio>
              </el-radio-group>
            </div>
            <div style="margin-bottom:30px">
              <p style="margin-bottom:20px">2,  您对我们设施的满意程度感觉如何</p>
              <el-radio-group v-model="pollForm.q2">
                 <el-radio :label="1">非常满意</el-radio>
                 <el-radio :label="2">满意</el-radio>
                 <el-radio :label="3">一般</el-radio>
                 <el-radio :label="4">不满意</el-radio>
              </el-radio-group>
            </div>
            <div style="margin-bottom:30px">
              <p style="margin-bottom:20px">3,  您对业务流程的满意程度感觉如何</p>
              <el-radio-group v-model="pollForm.q3">
                 <el-radio :label="1">非常满意</el-radio>
                 <el-radio :label="2">满意</el-radio>
                 <el-radio :label="3">一般</el-radio>
                 <el-radio :label="4">不满意</el-radio>
              </el-radio-group>
            </div>
            <div style="margin-bottom:30px">
              <p style="margin-bottom:20px">4,  您有什么对我们的建议</p>
              <p style="margin-bottom:20px;padding-left:10px;color:#ccc">您的评价对我们的服务提升很重要</p>
              <el-input type="textarea" v-model="pollForm.q4"></el-input>
            </div>
            <div style="margin-bottom:30px">
              <p style="margin-bottom:20px">  个人信息</p>
              <el-row>
                <el-col :span="12">
                    <el-form-item label="手机号" prop="phone">
                          <el-input v-model="pollForm.phone"></el-input>
                     </el-form-item>
                </el-col>
                <!-- <el-col :span="12">
                    <el-form-item label="姓名">
                          <el-input v-model="pollForm.name"></el-input>
                     </el-form-item>
                </el-col> -->
              </el-row>
            </div>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="poll = false">取 消</el-button>
            <el-button style="background:#8E8E8E;border:none;" type="primary" @click="pollCommit('pollForm')">提 交</el-button>
          </span>
       </el-dialog>
       <!-- 监督举报 -->
       <el-dialog
            title="监督举报"
            :visible.sync="feedbackDialog"
            width="50%"
            center
            :before-close="handleClose">
            <el-form ref="feedbackForm" :model="feedbackForm" label-width="100px" class="supervise" label-position="top">
            <el-row>
             <el-col :span="12">
                <el-form-item label="姓名">
                  <el-input v-model="feedbackForm.name" style="width:80%"></el-input>
                </el-form-item>
               </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="联系方式">
                  <el-input v-model="feedbackForm.phone" style="width:80%"></el-input>
                </el-form-item>
            </el-col>
          </el-row>
            <el-form-item label="举报内容">
                  <el-input type="textarea" v-model="feedbackForm.leaveWord"></el-input>
                </el-form-item>
          </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="feedbackDialog = false">取 消</el-button>
              <el-button style="background:#8E8E8E;border:none;" type="primary" @click="feedbackCommit">提 交</el-button>
            </span>
        </el-dialog>
        <!-- 墓位信息查询 -->
        <el-dialog
          title="墓位信息查询"
          :visible.sync="tombSiteSearchDialog"
          width="60%"
          center
          :before-close="handleClose">
          <el-form ref="tombSiteForm" :model="tombSiteForm" :rules="rules" label-width="100px" label-position="top"  >
            <el-row>
                <!-- <el-col :span="6">
                    <el-form-item label="办理人姓名：" label-width="40%">
                      <el-input v-model="tombSiteForm.transactorName"/>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="身份证号：" prop="idNumber" label-width="70%">
                     <el-input v-model="tombSiteForm.idNumber"></el-input>
                    </el-form-item>
                </el-col> -->
                <el-col :span="8">
                    <el-form-item label="办理人：" >
                      <el-input v-model="tombSiteForm.transactorName" style="width:80%"/>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="使用人："  >
                     <el-input v-model="tombSiteForm.deathName" style="width:80%"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="安葬证编号："  prop="buryCode">
                      <el-input v-model="tombSiteForm.buryCode" style="width:80%"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                    <el-form-item >
                       <el-button style="background:#8E8E8E;border:none;" type="primary" @click="onSubmit('tombSiteForm')">查询</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
          </el-form>
          <div style="width:100%;height:1px;background-color:#ccc;margin:20px 0"></div>
          <el-table
            :data="tombSiteTableData"
            style="width: 100%"
            border>
            <el-table-column
              prop="graveCode"
              label="墓位位置"
              width="180">
            </el-table-column>
            <el-table-column
              prop="deathName"
              label="使用人"
              width="180">
            </el-table-column>
            <el-table-column
              prop="graveTypeC"
              label="墓位类型">
            </el-table-column>
            <el-table-column
              prop="graveStatusC"
              label="墓位状态">
            </el-table-column>
         </el-table>
          <span slot="footer" class="dialog-footer">
            <!-- <el-button @click="tombSiteSearchDialog = false">取 消</el-button> -->
            <!-- <el-button type="primary" @click="tombSiteSearchDialog = false">确 定</el-button> -->
          </span>
       </el-dialog>
       <!-- 代客祭扫预约 -->
        <el-dialog
          title="代客祭扫预约"
          :visible.sync="valetDialog"
          width="60%"
          center
          :before-close="handleClose">
          <el-form ref="valetForm" :model="valetForm" :rules="rules" label-width="100px" label-position="top" >
            <el-row>
               <el-col :span="6">
                    <el-form-item label="墓穴位置" >
                     <el-input v-model="valetForm.address" style="width:80%"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="使用人" prop="name">
                     <el-input v-model="valetForm.name" style="width:80%"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="办理人" prop="blrName">
                     <el-input v-model="valetForm.blrName" style="width:80%"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="安葬证编号" >
                     <el-input v-model="valetForm.azCode" style="width:80%"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>

              <el-col :span="12">
                    <el-form-item label-width="120px">
                       <el-button style="background:#8E8E8E;border:none;" type="primary" @click="valetQuery('valetForm')">查询</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
          </el-form>
          <div style="width:100%;height:1px;background-color:#ccc;margin:20px 0"></div>
          <el-form ref="valetForm1" :model="valetForm1" :rules="rules" label-width="100px" label-position="top"  >
            <el-row>
                <el-col :span="5">
                    <el-form-item label="服务项目" >
                      <el-select v-model="valetForm1.serve" placeholder="请选择" style="width:80%"  @change="ChangeTc">
                      <el-option v-for="(item,index) in tcList" :key="index" :label="item.mealName" :value="item.id" />
                    </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="墓穴信息" >
                      <el-select v-model="valetForm1.graveCode" placeholder="请选择" style="width:80%">
                      <el-option v-for="(item,index) in mwList" :key="index" :label="item.code" :value="item.code" />
                    </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="祭祀日期" >
                      <el-date-picker
      v-model="valetForm1.serveTime"
      type="date"
      placeholder="选择日期"
      :picker-options="pickerOptions"
      style="width:80%">
    </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="联系人" >
                      <el-input v-model="valetForm1.field1" placeholder="请输入" style="width:80%"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="联系方式" >
                      <el-input v-model="valetForm1.phone" placeholder="请输入" style="width:80%"></el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="6">
                    <el-form-item label="祭祀物品" label-width="200px">
                      <el-select v-model="valetForm1.inventoryList" multiple placeholder="请选择" style="width:80%">
                      <el-option v-for="(item,index) in wpList" :key="index" :label="item.name" :value="item.name" />
                    </el-select>
                    </el-form-item>
                </el-col> -->
            </el-row>
             <el-row>
              <el-col :span="5">
                    <el-form-item label="套餐详情" >
                      <el-input  :rows="3" v-model="tcDetail" style="width:80%"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="套餐图片" >
                      <img :src="tcImg" style="height:100px;"/>
                    </el-form-item>
                </el-col>
             </el-row>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button @click="valetDialog = false">取 消</el-button>
            <el-button style="background:#8E8E8E;border:none;" type="primary" @click="valetCommit('valetForm1')">提 交</el-button>
          </span>
          <!-- https://my-st1.orangebank.com.cn:567/fat7/openapi/gateway/ -->
    <div v-show="false">
      <form id="zfForm" action="https://openbank.pingan.com/brcp/openbank/openapi/gateway/V1.0/order/tradeCashier" method="post">
        <input type="hidden" name="TraderNo" id="TraderNo" :value="payForm.traderNo" />
        <input type="hidden" name="TranAmt" id="TranAmt" :value="payForm.tranAmt" />
        <input type="hidden" name="OrderName" id="OrderName" :value="payForm.orderName" />
        <input type="hidden" name="OrderRemark" id="OrderRemark" :value="payForm.orderRemark" />
        <input type="hidden" name="ClientType" id="ClientType" value="pc" />
        <input type="hidden" name="ClientNo" id="ClientNo" :value="payForm.clientNo" />
        <input type="hidden" name="clientId" id="clientId" :value="payForm.clientId" />
        <input type="hidden" name="CallBackNoticeUrl" id="CallBackNoticeUrl" :value="payForm.callBackNoticeUrl" />
        <input type="hidden" name="Signature" id="Signature" :value="payForm.signature" />
        <input type="hidden" name="OrderSendTime" id="OrderSendTime" :value="payForm.orderSendTime" />
        <input type="hidden" name="TraderOrderNo" id="TraderOrderNo" :value="payForm.traderOrderNo" />
        <input type="hidden" name="FrontSkipUrl" id="FrontSkipUrl" :value="payForm.frontSkipUrl" />
        <!-- <input type="submit" id="submit1" value="付款"> -->
        <button style="background:#8E8E8E;border:none;color:#fff;
        height: 30px;width: 80px;" id="submit1" @click="OnPay()">付款</button>
      </form>
    </div>
       </el-dialog>
       <el-dialog :visible.sync="imgdialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
       </el-dialog>





	</div>
</template>

<style lang='stylus' scoped>
>>> .el-card {
}

::-webkit-scrollbar {
  width: 50px;
}

>>> .el-icon-close:before {
  color: #000;
}

>>> .el-dialog__header {
  background-color: #8E8E8E !important;
}

>>> .el-dialog__title {
  color: white !important;
}

.el-form-item__label {
  font-size: 18px;
}

.supervise .dialog-footer .el-form-item__label {
  font-size: 18px;
}

.supervise .el-button {
  width: 150px;
  font-size: 18px;
}

.el-form p {
  font-size: 20px;
  font-weight: 600;
}

>>> .el-radio__label {
  font-size: 18px;
}

>>> .el-textarea__inner {
  height: 200px;
}

.cursor:hover {
  cursor: pointer;
}

.service-box {
  // text-align: center
}

.expense-settlement {
  margin-top: 30px;
  text-align: center;

  .expense-settlement-button {
    width: 150px;
    height: 60px;
    font-size: 20px;
  }
}

.service-banner {
  display: flex;

  img {
    width: 60%;
    height: 300px;
    background-color: red;
  }

  .service-banner-right {
    width: 40%;
    margin-left: 50px;

    .banner-right {
      display: flex;
      justify-content: center;
    }

    h1 {
      font-size: 24px;
    }

    p {
      font-size: 18px;
      margin-top: 30px;
    }
  }
}
.roll-box{
  width:1200px;
  height:240px;

}
>>>.el-carousel__container{
  height:240px;
}
>>> .el-table .edit-cell .el-input__inner {
  border: 0;
  width: 100px;
}
>>>.el-tabs--border-card>.el-tabs__content{
  padding:5px 15px;
}
>>>.el-tabs__nav{
  margin-left:-19px;
}
.el-tabs--border-card {
  background: #DFDFDF !important;

  border: none;
}

.el-tabs--border-card /deep/ .el-tabs__header {
  background: #DFDFDF !important;
  border: none;
}

.box-wrap .el-tabs--border-card, .box-wrap .el-tabs--border-card /deep/ .el-tabs__header, .box-wrap .el-tabs--border-card /deep/ .el-tabs__header .el-tabs__item.is-active {
  background: none !important;
}

.box-wrap {
  .funeral {
    .el-card {
      background: none;
    }
  }
}

.chat_main {
  // float: left;
  width: 400px;
  height: 546px;
  border: 1px solid seagreen;
  background-color: #fff;
  background-size: cover;

  i {
    font-size: 24px;
    margin-left: 370px;
  }
}

.send_message {
  width: 400px;
  height: 65px;
  position: absolute;
  bottom: 0px;
  background: linear-gradient(to top, rgba(9, 216, 237, 0.99), #72cad4);
}

.send_message input[type='text'] {
  width: 340px;
  height: 30px;
  margin-top: 16px;
  margin-left: 10px;
  border-radius: 10px 0 0 10px;
  text-indent: 2em;
  outline: none;
  background-color: white;
  border: none;
}

.send_message input[type='button'] {
  border-radius: 0 10px 10px 0;
  width: 35px;
  height: 30px;
  background-color: white;
  border: none;
  margin-left: 0;
  background-color: white;
  border: none;
  outline: none;
}

.send_message input[type='button']:hover {
  background-color: orangered;
}

.send_message input[type='button']:active {
  background-color: #879eee;
}

.chat_namecard {
  float: left;
  width: 245px;
  height: 546px;
  border: 1px solid saddlebrown;
  background-color: #f1fea9;
}

.chat_content ul {
  list-style-type: none;
}

.chat_content {
  overflow: auto;
  width: 540px;
  /* 设置高度滚动条才有效 */
  height: 470px;
}

.chat_content li {
  margin-top: 10px;
  width: 540px;
  clear: both;
  display: block;
}

.chat_content li img {
  margin: 6px 0 0 0;
}

.chat_content li span {
  background: #ffd351;
  padding: 10px;
  border-radius: 10px;
  /* 最大宽度不能太长，不然布局会混乱 */
  max-width: 400px;
  border: 1px solid white;
  box-shadow: 0 0 3px #879eee;
  margin: 6px 10px 0 10px;
  overflow: hidden;
}

.chat_content li img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.chat_content li img.imgleft {
  margin-left: 10px;
  float: left;
}

.chat_content li img.imgright {
  margin-right: 10px;
  float: right;
}

.chat_content li span.spanleft {
  float: left;
}

.chat_content li span.spanright {
  float: right;
}

.el-input {
  width: 228px;
}

.main {
  position: relative;
}

.main-right {
  z-index:99999;
  position: fixed;
  // background-color: #fff;
  text-align: center;
  right: 50px;
  width: 100px;
  height: 200px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  p {
    font-size: 18px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  img {
    width: 50px;
    height: 50px;
  }
}

.dialog_item {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 400px;
  height: 500px;
  z-index: 99999;
}

.hots {
  // border: white solid 10px;
}

.hotItem{
  display: flex;
  justify-content: center;
}
.hot-label {
  display:flex;
  // left: 0.5px;
  bottom: 0px;
  width:100%;
  z-index: 2;
  height: 46px;
  line-height: 46px;
  color: white;
  background-color: #BAB4A6;
  opacity: 0.9;
}

.hot-title {
  font-size: 18px;
  flex: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

.hot-indexs {
  width: 90px;
}

.hot-index {
  width: 18px;
  height: 18px;
  line-height: 18px;
  font-size: 16px;
  font-weight: 500;
  margin-left: 10px;
}
//滚动到的颜色
.index-cur {
  background-color: #8E8E8E;
}
//滚动前的颜色
.index-def {
  background-color: #BAB4A6;
}

.news-main {
  padding: 0;
  margin-left: 20px;
  min-width: 654px;
}

.public-tabs {
  // padding-bottom: 14px;
  // min-height: 406px;
  height: 100%;
  overflow: hidden;
}

.public-tab {
  padding-bottom: 14px;
  min-height: 423.5px;
}

.new {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #394558;
  border-bottom: #d0d0d0 dashed 1px;
  line-height: 40px;
}

.new-link {
  flex: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

.new a:hover {
  color: #2A77D0;
}

.time {
  width: 120px;
}

.content {
  min-width: 1200px;
  max-width: 1200px;
  width: 1200px;
  margin:0px auto;
  margin-botton:5px;
}

.box-wrap {
  margin-top: 20px;
  width: 100%;
  // box-shadow: 0px 0px 5px 0px #cac2c2;
  // padding: 3px 15px;
  // background: #DFDFDF;
  background: url('../../../static/image/bgbottom.png') no-repeat center center;
  background-size: contain;
  height: 684px;
  overflow: hidden;
}

.content-wrap {
  // border:1px solid red;
  // margin-top:-4.2%;
// width: 100%;
// background: url('../../../static/image/bg.png') no-repeat center center;
// background-size: cover;
// height: 1080px;
// overflow: hidden;
}
.two-warp{
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
}
.beijing-warp{
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
  background: url('../../../static/image/footImg.png') no-repeat center center;
  background-size: 100%;
}
.scollItem{
  width: 850px;
  height: 4px;
  background: linear-gradient(to right , #131313,#DCDCDC);
  position: absolute;
  top: 29px;
  right: 20px;
  z-index: 999;

}

.dynamic-main, .culture-main {
  padding: 0;
  min-width: 780px;
  // margin-top:-27px;
}

.dynamics {
  font-size: 0;
}

.dynamic {
  margin-left: 9.5px;
  margin-right: 9.5px;
  width: 280px;
}

.dynamic-title {
  font-size: 20px;
  background-color: #F5F7FA;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 9.5px;
  margin-right: 9.5px;
  width: 100%;
}

.funeral {
  margin-left: 10px;

  .el-card {
    background: #DFDFDF;
  }
}

.funeral-header {
  height: 60px;
  line-height: 60px;
  // background: #C69D49;
  color: #020202;
  font-size: 25px;
  text-indent: 20px;
}

.car {
  height: 60px;
  line-height: 60px;
  background: linear-gradient(90deg, #FFCA5A, #FFAE00);
  border: 2px solid #EFAF25;
  border-radius: 5px;
  font-size: 26px;
  text-indent: 20px;
}

.car a {
  color: white;
  flex: 1;
}

.arrow {
  top: 8px;

}

.home {
  width: 70px;
  background-color: #FFF9E1;
}

.mechanism {
  margin-top: 14px;
}

.box-card:first-of-type {
  // margin-bottom: 8px;
  // background: red;ss
}

.box-card {
  border:none;
  min-width: 398px;
}

.reserve {
  height: 38px;
  line-height: 38px;
  background: #CBCBCB;
  font-size: 20px;
  text-indent: 10px;
}

.reserve-wrapper:not(:nth-last-child(-n+1)) {
  margin-bottom: 10px;
}

.reserve-icon {
  top: 4px;
  // background: #A08A5C;
}

.main-right p {
  color: #020202;
}
.peopleItem{
  width:250px;
  height:300px;
  margin-right:10px
  position: relative;
}
.starItem{
  border:1px solid red;
  position:absolute;
  z-index:999;
  font-size:24px;
  color:#FFF;
  top:250px;
  left:125px;
}
</style>

<script>
import moment from "moment";
import { slider, slideritem } from "vue-concise-slider";
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  name: "index",
  data() {
    return {
      payForm:{
        traderNo:"",
        tranAmt:"",
        orderName:"",
        orderRemark:"",
        clientNo:"",
        clientId:"6eac7222-cbf5-4551-b861-3a72bb7c6c74",
        callBackNoticeUrl:"",
        signature:"",
        orderSendTime:"",
        traderOrderNo:"",
        frontSkipUrl:"",
      },

      tcImg:'',
      tcDetail:'',
      afterInfo:'',
      info_text:'',
      qygkList: [],
      bzwhList: [],
      djzxList: [],
      hyzxList: [],
      xwdtimgs: [],
      jqbdimgs: [],
      gyyqimgs:{
        data: [],
        page: 1,
        total: 0
      },
      starimgs:{
        data: [],
        page: 1,
        total: 0
      },
      dialogImageUrl: "",
      imgdialogVisible: false,
      //民意调查表单
      pollForm: {
        q1: "",
        q2: "",
        q3: "",
        q4: "",
        phone: "",
      },
      //监督举报表单
      feedbackForm: {
        name: "",
        phone: "",
        leaveWord: "",
        feedbackType: 2,
      },
      valetDialog: false,
      valetForm: {
        address: "",
        name: "",
        blrName: "",
        azCode: "",
      },
      valetForm1: {
        graveCode: "",
        serve: "",
        inventoryList: [],
        serveTime: "",
        field1: "",
        phone:"",
      },
      v: 0,
      imgs: [
        {
          url: "/static/image/one.png",
          id: 0,
          style: {
            background: "#4abf8a",
            width: "23.5%",
            "margin-right": "2%",
          },
        },
        {
          url: "/static/image/two.png",
          id: 1,
          style: {
            background: "#4abf8a",
            width: "23.5%",
            "margin-right": "2%",
          },
        },
        {
          url: "/static/image/three.png",
          id: 2,
          style: {
            background: "#4abf8a",
            width: "23.5%",
            "margin-right": "2%",
          },
        },
        {
          url: "/static/image/four.png",
          id: 3,
          style: {
            background: "#4abf8a",
            width: "23.5%",
            "margin-right": "2%",
          },
        },
        {
          url: "/static/image/fiver.png",
          id: 4,
          style: {
            background: "#4abf8a",
            width: "23.5%",
            "margin-right": "2%",
          },
        },
        // {url:'/static/image/two.png'},
        // {url:'/static/image/three.png'},
        // {url:'/static/image/four.png'},
        // {url:'/static/image/three.png'},
      ],
      mxTypeList: [
        {
          id: 1,
          text: "单人墓",
        },
        {
          id: 2,
          text: "双人墓",
        },
        {
          id: 3,
          text: "多人墓",
        },
        {
          id: 4,
          text: "家族墓",
        },
        {
          id: 5,
          text: "生态墓",
        },
        {
          id: 9,
          text: "其他墓",
        },
      ],
      mwList: [],
      tcList: [],
      wpList: [],
      options: {
        //  currentPage: 0,
        freeze: false,
        nested: false,
        tracking: false,
        thresholdDistance: 100,
        thresholdTime: 300,
        loopedSlides: 5,
        infinite: 4,
        effect: "slide",
        slidesToScroll: 1,
        timingFunction: "ease",
        itemAnimation: true,
        preventRebound: false,
        //   currentPage:0,
        autoplay: 2000, //自动滚动[ms]
        loop: true,
      },
      reportList: [],
      journalismList: [
        {
          text: "市殡馆处全员军训完美收官",
          date: "2020-8-23",
        },
        {
          text: "安全生产月回头看",
          date: "2020-8-23",
        },
        {
          text: "党群共建主体活动",
          date: "2020-8-23",
        },
        {
          text: "2022年安全生产月专题",
          date: "2020-8-23",
        },
      ],
      serverUrl: this.$store.state.config.serverUrl,
      staticUrl: this.$store.state.config.staticUrl,
      hots: [],
      hotActive: 0,
      publicities: [],
      news: [],
      dynamics: [],
      recents: [],
      culture: [],
      policy: [],
      standard: [],
      serviceindex: [],
      price: [],
      style: [],
      binyiguan: [],
      moment,
      show: true,
      zixunshow: false,
      dialogVisible: false,
      actingSacrificeShow: false,
      servicedialog: false,
      expenseSettlementDilog: false,
      feedbackDialog: false,
      poll: false,
      tombSiteSearchDialog: false,
      ruleForm: {
        name: "",
        expectationType: null,
        phone: "",
        expectationTime: "",
        expectationHighest: "",
        expectationLowest: "",
        remark: "",
      },
      form: {
        idNumber: "",
        name: "",
      },
      tombSiteForm: {
        transactorName: "",
        deathName: "",
        buryCode:'',
      },
      checkList: ["选中且禁用", "复选框 A"],

      tableData: [
        {
          serviceContent: "墓碑清洁",
          quantity: "0",
          unitPrice: "15",
          totalAmount: "",
        },
        {
          serviceContent: "奉鲜花",
          quantity: "0",
          unitPrice: "15",
          totalAmount: "",
        },
        {
          serviceContent: "奉酒",
          quantity: "0",
          unitPrice: "15",
          totalAmount: "",
        },
        {
          serviceContent: "奉香、烛",
          quantity: "0",
          unitPrice: "15",
          totalAmount: "",
        },
        {
          serviceContent: "鞠躬",
          quantity: "0",
          unitPrice: "15",
          totalAmount: "",
        },
        {
          serviceContent: "摆放供果三种",
          quantity: "0",
          unitPrice: "15",
          totalAmount: "",
        },
        {
          serviceContent: "代读思亲赋",
          quantity: "0",
          unitPrice: "15",
          totalAmount: "",
        },
        {
          serviceContent: "现场视频或成品照片",
          quantity: "0",
          unitPrice: "15",
          totalAmount: "",
        },
      ],
      tombSiteTableData: [],
      rules: {
        buryCode:[{ required: true, message: "请输入安葬证编号", trigger: "blur" }],
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        blrName: [{ required: true, message: "请输入", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern:
              /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/,
            message: "手机号不合法",
          },
        ],
        idCard: [
          { required: true, message: "请输入证件号码", trigger: "blur" },
          {
            pattern:
              /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/,
            message: "证件号码不合法",
          },
        ],
        region: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
        contacts: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          {
            min: 8,
            max: 12,
            message: "长度在 8 到 12 个字符",
            trigger: "blur",
          },
        ],
        minPrice: [
          { required: true, message: "请输入最小价格", trigger: "blur" },
        ],
        maxPrice: [
          { required: true, message: "请输入最大价格", trigger: "blur" },
        ],
        value1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      dyIndex: "1",
      xyIndex: "0",
    };
  },
  components: {
    slider,
    slideritem,
    vueSeamlessScroll,
  },
  computed: {
    defaultOption() {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
    defaultOptionNew() {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
    token() {
      return this.$store.state.user.token
    }
  },
  created() {
    this.getgyyqimgs(1, 'house');
    this.getstarimgs(1, 'public');
    this.getqygkList();
    this.getbzwhList();
    this.getdjzxList();
    this.gethyzxList();

    this.getNewsImg();
    this.getInfoGg();
    this.getInfoLydt();
    this.getInfoXwdt();
    this.getjqbdimgs();
    this.getxwdtimgs();
    this.getInfoJqbd();
    // this.articleIndex("hots", 3);
    // this.articleIndex("publicities", 5);
    // this.articleIndex("news", 5);
    // this.articleIndex("dynamics", 10);
    // this.articleIndex("recents", 10);
    // this.articleIndex("culture", 5);
    // this.articleIndex("policy", 5);
    // this.articleIndex("standard", 5);
    // this.articleIndex("serviceindex", 5);
    // this.articleIndex("price", 5);
    // this.articleIndex("style", 5);
    // this.articleIndex("binyiguan", 1);

    setInterval(() => {
      if (this.v >= 2) {
        this.v = 0;
      } else {
        this.v++;
      }
    }, 2000);
  },
  methods: {
    commitNews(){
      this.afterInfo = this.info_text;
      this.info_text = '';
    },
    //公益园区、名人纪念馆图片接口
    getgyyqimgs(page,type){
        let query = {
          currentPage: page,
          pageSize: 1000,
          typeof:2,
        };
        this.$xaxios.post('/app/memorialInfo/searchOther/No', query).then((res) => {
          console.log(res,"-----公益园区-----");
          if(res.code == 2000) {
            this.gyyqimgs.data = res.data
          }else{
            this.$message.error(res.msg)
          }
        })
    },
    getstarimgs(page,type){
      let query = {
          currentPage: page,
          pageSize: 1000,
          typeof:3,
        };
        this.$xaxios.post('/app/memorialInfo/searchOther/No', query).then((res) => {
          console.log(res,"-----名人纪念馆-----");
          if(res.code == 2000) {
            this.starimgs.data = res.data
          }else{
            this.$message.error(res.msg)
          }
        })
    },
    //预约看墓提交
    orderCommit(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          this.$http.post("appointment/grave", this.ruleForm).then((res) => {
            if (res.data.code == 200) {
              this.$message.success("预约成功");
              this.dialogVisible = false;
              this.ruleForm = {};
            } else {
              this.$message.error(res.data.errorMessage);
            }
            console.log(res.data, "预约看墓");
          });
        } else {
          console.log("校验失败");
          return false;
        }
      });
    },
    //墓位信息查询
    onSubmit(tombSiteForm) {
      this.$refs[tombSiteForm].validate((valid) => {
        if (valid) {
          this.$http
            .get(
              `/grave/get?transactorName=${this.tombSiteForm.transactorName}&deathName=${this.tombSiteForm.deathName}&buryCode=${this.tombSiteForm.buryCode}`
            )
            .then((res) => {
              if (res.data.code == 200) {
                console.log(res.data, "查询墓位信息");
                this.tombSiteTableData = res.data.data;
              } else {
                this.$message.error(res.data.errorMessage);
              }
            });
        } else {
          console.log("校验失败");
          return false;
        }
      });
    },
    //民意调查确定
    pollCommit(pollForm) {
      this.$refs[pollForm].validate((valid) => {
        if (valid) {
          this.$http.post("/question/question", this.pollForm).then((res) => {
            console.log(res.data, "民意调查");
            if (res.data.code == 200) {
              this.$message.success("提交成功");
              this.poll = false;
              this.pollForm = {};
            } else {
              this.$message.error(res.data.errorMessage);
            }
          });
        } else {
          console.log("校验失败");
          return false;
        }
      });
    },
    //监督举报确定
    feedbackCommit() {
      this.$http.post("/feedback/save", this.feedbackForm).then((res) => {
        console.log(res.data, "监督举报");
        if (res.data.code == 200) {
          this.$message.success("举报成功");
          this.feedbackDialog = false;
          this.feedbackForm = {};
        } else {
          this.$message.error(res.data.errorMessage);
        }
      });
    },
    //改变套餐的值
    ChangeTc(e){
      console.log(e,"选中的值");
      let imgUrls = this.tcList.find(x => x.id == e)
      console.log(imgUrls,"选中套餐的图片");
      this.tcImg = imgUrls.imagesUrl
      this.tcDetail = imgUrls.mealPage
      // console.log(this.tcImg,"----");
    },
    //获取套餐--代客祭扫
    getTc() {
      this.$http.get("/sacrifice/meal/getPro").then((res) => {
        console.log(res.data, "服务项目-套餐");
        if (res.data.code == 200) {
          this.tcList = res.data.data;
          console.log(this.tcList,"代客祭祀的服务项目套餐");
        } else {
          this.$message.error(res.data.errorMessage);
        }
      });
    },
    //获取物品--代客祭扫
    getWp() {
      this.$http.get("/sacrifice/goods/get").then((res) => {
        console.log(res.data, "祭祀物品");
        if (res.data.code == 200) {
          this.wpList = res.data.data;
        } else {
          this.$message.error(res.data.errorMessage);
        }
      });
    },
    //通过手机号查询墓穴列表，如果已经预约过了就会显示预约过的信息，如果没有预约过就回显墓穴列表
    valetQuery() {
      this.$refs['valetForm'].validate((valid) => {
        if(valid){
          this.$http
        .get(
          `/sacrifice/inquire/getone?address=${this.valetForm.address}&name=${this.valetForm.name}
              &blrName=${this.valetForm.blrName}&azCode=${this.valetForm.azCode}`
        )
        .then((res) => {
          console.log(res.data, "11111111");
          this.valetForm1 = {}
          if (res.data.code == 200) {
            this.mwList = res.data.data.graveCode;
          } else {
            this.$message.error(res.data.errorMessage);
          }
        });
        }
      })

      // this.$refs[valetForm].validate((valid) => {
      //   if (valid) {
      //     this.$http
      //       .get(
      //         `/grave/sacrifice/subscribe?address=${this.valetForm.address}&name=${this.valetForm.name}
      //         &phone=${this.valetForm.phone}&idCard=${this.valetForm.idCard}`
      //       )
      //       .then((res) => {
      //         console.log(res.data, "11111111");
      //         if (res.data.code == 200) {
      //           this.mwList = res.data.data.graveCode;
      //         } else {
      //           this.$message.error(res.data.errorMessage);
      //         }
      //       });
      //   } else {
      //     console.log("校验失败");
      //     return false;
      //   }
      // });
    },
    //代客祭扫提交
    valetCommit(valetForm1) {
      if (this.valetForm.idCard == "") {
        this.$message.error("请输入身份证号");
      }
      // let obj = {
      //   ...this.valetForm,
      //   ...this.valetForm1,
      // };
      this.$refs[valetForm1].validate((valid) => {
        if (valid) {
          this.$http
            .post("/sacrifice/save/sacrifice", {
              ...this.valetForm,
              ...this.valetForm1,
            })
            .then((res) => {
              console.log(res.data, "代客祭扫数据");
              if (res.data.code == 200) {
                this.payForm = res.data.data;
                this.$message.success("预约成功");
                this.valetDialog = false;
                this.valetForm = {};
                this.valetForm1 = {};
                console.log(this.payForm,"返参");
                this.$nextTick(function (){
                  this.payForm = res.data.data;
                  document.getElementById("submit1").click()
                })
              } else {
                this.$message.error(res.data.errorMessage);
              }
            });
        } else {
          console.log("校验失败");
          return false;
        }
      });
    },
    OnPay(){
      this.valetDialog = false;
    },
    handleClick(tab, event) {
      console.log(tab, event, "点击tab页");
    },
    handleClose() {
      this.dialogVisible = false;
      this.tombSiteSearchDialog = false;
      this.poll = false;
      this.feedbackDialog = false;
      this.valetDialog = false;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onmouseover() {
      this.options.loop = false;
    },
    quantityChange(value, index) {
      this.tableData[index].totalAmount = Number(
        this.tableData[index].quantity * this.tableData[index].unitPrice
      ).toFixed(2);
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      console.log("77", val);
      this.multipleSelection = val;
    },
    // 代理祭祀确定
    btnactingSacrificeShow() {
      this.actingSacrificeShow = false;
      this.servicedialog = true;
    },
    //代理祭祀费用结算
    expenseSettlementButton() {
      this.expenseSettlementDilog = true;
    },
    //在线咨询
    onlineConsulting() {
      this.show = false;
      this.info_text = ''
      this.afterInfo = ''
      this.zixunshow = true;
    },
    //在线咨询的关闭
    btnclose() {
      this.show = true;
      this.zixunshow = false;
    },
    //内部办公
    insideWork(){
      window.location.href="http://gm.ccjly.com/"
    },
    // 预约看墓弹窗
    btntomb() {
      this.dialogVisible = true;
    },
    //代客祭扫预约
    ValetSweep() {
      this.valetForm = {};
      this.valetForm1 = {};
      this.mwList = [];
      this.tcDetail = ''
      this.tcImg = ''
      this.valetDialog = true;
      this.getTc();
      this.getWp();
    },
    // 代理祭祀弹窗
    actingSacrifice() {
      this.actingSacrificeShow = true;
    },
    //民意调查弹窗
    btnpoll() {
      this.poll = true;
    },
    // 监督举报弹窗
    supervisionInvestigation() {
      this.feedbackDialog = true;
    },
    //墓位信息查询
    tombSiteSearch() {
      this.tombSiteForm = {};
      this.tombSiteTableData = [];
      this.tombSiteSearchDialog = true;
    },
    go(url) {
      this.$router.replace(url);
    },
    // articleIndex(name, pageSize) {
    //   this.$http
    //     .get("cms/cmsContent/queryContentByCategoryName", {
    //       params: { name: name, pageNo: 1, pageSize: pageSize },
    //     })
    //     .then((res) => {
    //       this[name] = res.data.result.records;
    //     });
    // },
    getNewsImg() {
      this.$http.get("menu/news").then((res) => {
        console.log(res, "新闻图片和标题");
        this.hots = res.data.data;
      });
    },
    getInfoGg() {
      this.$http
        .post("article/get", {
          type: 4,
        })
        .then((res) => {
          console.log(res, "通知公告");
          this.publicities = res.data.data;
        });
    },
    getInfoLydt() {
      this.$http
        .post("article/get", {
          type: 2,
        })
        .then((res) => {
          console.log(res, "龙源动态");
          this.news = res.data.data;
        });
    },
    getxwdtimgs() {
      this.$http.get("menu/news/img").then((res) => {
        console.log(res, "-----0000000");
        this.xwdtimgs = res.data.data;
      });
    },
    getjqbdimgs() {
      this.$http.get("menu/news/img/recent").then((res) => {
        console.log(res, "-----88888");
        this.jqbdimgs = res.data.data;
        console.log(this.jqbdimgs, "-----88888");
      });
    },
    getqygkList() {
      this.$http
        .post("article/get", {
          type: 1,
        })
        .then((res) => {
          console.log(res, "企业概况");
          this.qygkList = res.data.data;
        });
    },
    getbzwhList() {
      this.$http
        .post("article/get", {
          type: 7,
        })
        .then((res) => {
          console.log(res, "殡葬文化");
          this.bzwhList = res.data.data;
        });
    },
    getdjzxList() {
      this.$http
        .post("article/get", {
          type: 6,
        })
        .then((res) => {
          console.log(res, "党建中心");
          this.djzxList = res.data.data;
        });
    },
    gethyzxList() {
      this.$http
        .post("article/get", {
          type: 3,
        })
        .then((res) => {
          console.log(res, "行业资讯");
          this.hyzxList = res.data.data;
        });
    },
    getInfoXwdt() {
      this.$http
        .post("article/get", {
          type: 8,
        })
        .then((res) => {
          console.log(res, "新闻动态");
          this.journalismList = res.data.data;
        });
    },
    getInfoJqbd() {
      this.$http.post("article/recent").then((res) => {
        console.log(res, "近期报道");
        this.reportList = res.data.data;
      });
    },
    handleCarousel(value) {
      this.hotActive = value;
    },
    changehot(index) {
      this.$refs.hots.setActiveItem(index);
    },
    comcarousel(field, count = 4) {
      let arr = [];
      let len = Math.ceil(this[field].length / count);
      for (let i = 0; i < len; i++) {
        arr.push([]);
      }
      this[field].forEach((item, index) => {
        arr[Math.floor(index / count)].push(item);
      });
      return arr;
    },
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?71f9566b